import React from "react";
import ReactModal from "react-modal";
import "./HeModal.scss";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationTriangle} from "@fortawesome/free-solid-svg-icons";
import { AnnotationCalloutCurve } from "react-annotation";
import { componentWillAppendToBody } from "react-append-to-body";


// Root elemaent is app dependent now, so commenting out for now
// ReactModal.setAppElement("#root");

function MyComponent({ children }) {
    return (
        <div className='HeModal-connector'>
            {children}
        </div>
    );
}
const AppendedMyComponent = componentWillAppendToBody(MyComponent);

class HeModal extends React.Component {
    constructor() {
        super();
        this.state = {
            modalAnnotationAnchor_x: 0,
            modalAnnotationAnchor_y: 0,
            modalAnnotationAnchor_pos:null
        };
        this.modalRef = React.createRef();
        // this.annotation = React.createRef();
    }

    componentDidUpdate() {
        setTimeout(() => {
            const newAnchorPoint = this.getModalAnnotationAnchorPoint();
            if ( !newAnchorPoint || (newAnchorPoint.x === this.state.modalAnnotationAnchor_x && newAnchorPoint.y === this.state.modalAnnotationAnchor_y)) {
                return;
            }
            this.setState({
                modalAnnotationAnchor_x: newAnchorPoint.x,
                modalAnnotationAnchor_y: newAnchorPoint.y,
                modalAnnotationAnchor_pos:newAnchorPoint.position
            });
        }, 10);
    }

    getModalAnnotationAnchorPoint() {
        let modalAnchorPoint = { x: 0, y: 0 };

        if (!this.modalRef.current || !this.props.isOpen) {
            return modalAnchorPoint;
        }
        
        const modalRect = this.modalRef.current.getBoundingClientRect();
        
        let anchorDistances = {
            left:  this.props.annotationAnchor.x < modalRect.left   ? (modalRect.left                   - this.props.annotationAnchor.x)    : 0,
            right: this.props.annotationAnchor.x > modalRect.right  ? (this.props.annotationAnchor.x    - modalRect.right)                  : 0,
            above: this.props.annotationAnchor.y < modalRect.top    ? (modalRect.top                    - this.props.annotationAnchor.y)    : 0,
            below: this.props.annotationAnchor.y > modalRect.bottom ? (this.props.annotationAnchor.y    - modalRect.bottom)                 : 0
        };

        let anchorPosition = null;
        let anchorDistance = 0;
        ['left','right','above','below'].forEach((position)=>{
            if (anchorDistances[position]>anchorDistance){
                anchorDistance = anchorDistances[position];
                anchorPosition = position;
            }
        });
        

        if (anchorPosition === 'left'){
            modalAnchorPoint.x = modalRect.left;
            modalAnchorPoint.y = modalRect.top + modalRect.height/2;         
        }
        else if (anchorPosition === 'right'){
            modalAnchorPoint.x = modalRect.right;
            modalAnchorPoint.y = modalRect.top + modalRect.height/2;         
        }
        else if (anchorPosition === 'above'){
            modalAnchorPoint.x = modalRect.left + modalRect.width / 2;
            modalAnchorPoint.y = modalRect.top;       
        }
        else if (anchorPosition === 'below'){
            modalAnchorPoint.x = modalRect.left + modalRect.width / 2;
            modalAnchorPoint.y = modalRect.bottom;       
        }
        // else{
        //     alert('still need to account for this one')
        // }
        
        modalAnchorPoint.position = anchorPosition;

        return anchorPosition ? modalAnchorPoint : null;
    }

    render() {
        return (
            <>
                <ReactModal isOpen={this.props.isOpen} onRequestClose={this.props.onCloseRequest} shouldCloseOnOverlayClick={this.props.shouldCloseOnOverlayClick} className={this.props.className+" HeModal"} overlayClassName="HeModal-Overlay">
                    <div className='sans' ref={this.modalRef} >
                        <div className="HeModal-Header">
                            {this.renderHeaderIcon()}
                            {this.props.headerText}
                        </div>
                        <div className="HeModal-Content" style={{maxHeight:'60vh', overflowY:'auto'}}>{this.props.content}</div>
                        <div className="HeModal-Footer">
                            {this.renderDownloadButton()}
                            {this.renderSaveButton()}
                            {this.renderCustomButton()}
                            <button  className={this.props.buttonClass} onClick={this.props.onCloseRequest}>{this.props.closeButtonLabel}</button>
                        </div>
                    </div>
                </ReactModal>
                {this.renderAnnotationCurve()}
            </>
        );
    }
    renderHeaderIcon() {
        if (!this.props.headerFontAwesomeIcon) return null;
        return <span className="HeModal-HeaderIcon">{this.props.headerFontAwesomeIcon}</span>
    }
    renderAnnotationCurve() {
        let inflectionProportion = {
            x: ['left','right'].indexOf(this.state.modalAnnotationAnchor_pos) >-1 ? 0.5 : 0.8,
            y: ['above','below'].indexOf(this.state.modalAnnotationAnchor_pos) >-1 ? 0.5:0.8
        };
        return (
            <AppendedMyComponent>
                <svg
                    style={{
                        display: 
                            (
                                !this.props.isOpen || 
                                !this.props.annotationAnchor || 
                                (this.props.annotationAnchor.x === 0 && this.props.annotationAnchor.y === 0) ||
                                (this.state.modalAnnotationAnchor_x === 0 && this.state.modalAnnotationAnchor_y === 0) 
                            ) ? "none" : "block",
                        pointerEvents: "none",
                        zIndex: 999999,
                        position: "absolute"
                    }}
                    // ref={this.annotationRef}
                    width={"100%"}
                    height={"100%"}
                >
                    <AnnotationCalloutCurve
                        x={this.props.annotationAnchor.x}
                        y={this.props.annotationAnchor.y}
                        nx={this.state.modalAnnotationAnchor_x}
                        ny={this.state.modalAnnotationAnchor_y}
                        color={"#ffffff"}
                        editMode={false}
                        note={{}}
                        connector={{ 
                            end: "dot",
                            endScale:5,
                            points:[[
                                inflectionProportion.x*(this.state.modalAnnotationAnchor_x-this.props.annotationAnchor.x),
                                inflectionProportion.y*(this.state.modalAnnotationAnchor_y-this.props.annotationAnchor.y)
                            ]]
                        }}
                    />
                </svg>
            </AppendedMyComponent>
        );
    }
    renderSaveButton() {
        if (!this.props.onSaveRequest) {
            return null;
        }
        return (
            <button disabled={this.props.isSaveButtonDisabled} className={this.props.buttonClass} style={{ marginRight: "10px" }} onClick={this.props.onSaveRequest}>
                Save
            </button>
        );
    }
    renderCustomButton() {
        if (!this.props.onCustomButtonRequest) {
            return null;
        }
        return (
            <button disabled={this.props.isCustomButtonDisabled} className={this.props.buttonClass} style={{ marginRight: "10px" }} onClick={this.props.onCustomButtonRequest}>
                {this.props.customButtonLabel}
            </button>
        );
    }
    renderDownloadButton() {
        if (!this.props.onDownloadRequest) {
            return null;
        }
        return (
            <button  disabled={this.props.isDownloanButtonDisabled} className={this.props.buttonClass} style={{ marginRight: "10px" }} onClick={this.props.onDownloadRequest}>
                Download
            </button>
        );
    }
}

HeModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    annotationAnchor: PropTypes.shape({ x: PropTypes.number, y: PropTypes.number }),
    content: PropTypes.element,
    headerText: PropTypes.string,
    headerFontAwesomeIcon: PropTypes.element,
    onCloseRequest: PropTypes.func,
    onSaveRequest: PropTypes.func,
    onDownloadRequest: PropTypes.func,
    shouldCloseOnOverlayClick: PropTypes.bool,
    closeButtonLabel: PropTypes.string,
    className:PropTypes.string,
    buttonClass:PropTypes.string,
    customButtonLabel:PropTypes.string,
    onCustomButtomRequest:PropTypes.func,
    isCustomButtonDisabled:PropTypes.bool,
    isSaveButtonDisabled:PropTypes.bool,
    isDownloanButtonDisabled:PropTypes.bool
};

HeModal.defaultProps = {
    annotationAnchor: { x: 0, y: 0 },
    headerFontAwesomeIcon: <FontAwesomeIcon icon={faExclamationTriangle} />,
    headerText: "This is a sample header",
    content: <p>Your Content will go here</p>,
    shouldCloseOnOverlayClick: true,
    closeButtonLabel: "Close",
    className:'',
    buttonClass:'',
    customButtonLabel:'custom button',
    isCustomButtonDisabled:false,
    isSaveButtonDisabled:false,
    isDownloanButtonDisabled:false
};

export default HeModal;
